import { AbstractDTO } from '../abstract';
import {FormButton} from "./button";

export class FormSettingsDTO extends AbstractDTO {
    formStageType: string;
    _buttons:FormButton[] = [];
    submitSpinner: boolean = false;
    markNextField: boolean = false;
    info: string = '';
    renderedInfo: string = '';
    _hasFcc: boolean = false;
    _fccFL: [string];
    nextButtonMode: string;
    closeButtonByScroll: boolean = true;
    hideLabel: boolean = false;
    viewModeLabelProperty: string;
    constructor(attributes?: Object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        Object.assign(this, attributes);

        this.formStageType = attributes['formStageType'];
        this.info = attributes['info'];
        this.buttons = attributes['buttons'];
        this.markNextField = attributes['markNextField'] || false;
        this.nextButtonMode = attributes['nextButtonMode'];
        this.closeButtonByScroll = attributes['closeButtonByScroll'];
        this.hideLabel = attributes['hideLabel'] || false;
        this.viewModeLabelProperty = attributes['viewModeLabelProperty'];
    }

    get hasFcc() { return this._hasFcc; }
    set hasFcc(value: boolean) { this._hasFcc = value; }

    set buttons(buttons) {
        if (!buttons || !Array.isArray(buttons) || !buttons.length) {
            this._buttons = [];
            return;
        }
        if (buttons[0] instanceof FormButton) {
            this._buttons = buttons;
        } else {
            this._buttons = FormButton.createFromArray(buttons);
        }
    }

    get buttons() {
        return this._buttons;
    }

    get fccFL() { return this._fccFL; }
    set fccFL(value: any) { this._fccFL = value; }
}
